import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "slash.forward.regular-20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { stroke: "currentColor", d: "M12.5 4.5l-5 11", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
